
import $ from 'jquery';
import { useEffect } from 'react';
import useMobile from '../../hooks/useMobile';
import IconButtons from '../../stories/Buttons/IconButtons';
import * as S from './VideoModal.styled';
import { YoutubeVideo } from '../../services/models';

export default function VideoModal({
	onClose,
	video,
}: {
	onClose: Function;
	video: YoutubeVideo;
}) {
  let { isMobile } = useMobile()
	const onModalClose = () => {
		onClose();
	};
	return (
		<S.VideoModal className='video-modal'>
			<div className="contents">
        <IconButtons
          size={!isMobile?54:30}
          icon={{
            name: 'close',
            width: !isMobile?32:18,
            height: !isMobile?32:18
          }}
          onClick={onModalClose}
          rounded={true}
          reverse={true}
          className='close-button'
        />
				<div className='thumbnail'>
					<iframe
						src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}?rel=0&amp;vq=hd1080`}
					/>

				</div>
			</div>
		</S.VideoModal>
	);
}
